<template>
    <section class="py-5 py-md-10 border-bottom">
        <div class="row mb-md-8">
            <div class="col-lg-4">
                <span class="regular-title mr-1">{{!collectionFixed ? $t("components.ConfiguratorResumeSet.bedLinenSet") +" " : ""}}{{collectionName}}</span>
                <span class="small-title lightergray pb-3 mt-n1" v-if="productSetName">{{productSetName}}</span>
                <br/>
                <div class="note-beta" v-if="productSetTypeName">{{productSetTypeName}}</div>
            </div>
            <div class="col-lg-2 col-6 text-center py-3 py-md-0">
                <product-counter @input="setQuanitity" v-model="set.quantity" :allowZero="true"></product-counter>
                <confirm-delete-popup @confirm="submitDelete" @cancel="closeDeleteConfirmationPopup" :show="showConfirmPopup"></confirm-delete-popup>
            </div>

            <div class="col-lg-2 col-3 text-right py-3 py-md-0">
                <div class="priceAction">
                    <div class="priceAction__after">{{$nf(unitDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                    <div class="priceAction__before" v-if="unitDiscountPriceWithVat != price.priceWithVat">{{$nf(price.priceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                </div>
            </div>
            <div class="col-lg-2 col-3 text-right py-3 py-md-0">
                <div class="priceAction">
                    <div class="priceAction__after">{{$nf(totalDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                </div>
            </div>
        </div>
        <div class="row" v-if="isCurrentCollection && setMessage">
            <div class="col-md-7 note-delta p-1 mb-2 border border d-flex">
                <span class="tooltip tooltip--inactive mr-1"><span class="tooltip__icon">i</span></span>
                <div>
                    {{ setMessage }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7">
                <div class="note-beta mb-md-3">{{$t("components.ConfiguratorResumeSet.setContains")}}</div>
                <table class="radioSet__items setItems">
                    <configurator-resume-set-item :item="item" :key="item.id" v-for="item in set.items"></configurator-resume-set-item>
                </table>
                <div class="col-12 text-right py-3 py-md-0 mt-6 pr-md-3">
                    <div class="priceAction">
                        <div class="priceAction__after">{{$nf(unitDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                        <div class="priceAction__before" v-if="unitDiscountPriceWithVat != price.priceWithVat">{{$nf(price.priceWithVat, 'currency' + currencyCode, 'cs-CZ')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data: function () {
            return {
                quantityValue: 1,
                showConfirmPopup: false
            };
        },
        props: ["set"],
        computed: {
            discountPriceWithVat: function () {
                if(this.set.collectionId != this.$store.getters.currentCollectionId) {
                    return this.priceWithVat;
                }
                var price = this.priceWithVat;
                var selectedSet = this.$store.getters.getSelectedSet;
                if (selectedSet) {
                    price =
                        price -
                        (selectedSet.price.priceWithVat -
                            selectedSet.discountPrice.priceWithVat);
                }
                return price;
            },
            totalDiscountPriceWithVat: function() {
                return this.unitDiscountPriceWithVat * this.set.quantity;
            },
            unitDiscountPriceWithVat: function () {
                if(this.set.collectionId != this.$store.getters.currentCollectionId) {
                    return this.price.priceWithVat;
                }
                var price = this.price.priceWithVat;
                var selectedSet = this.$store.getters.getSelectedSet;
                if (selectedSet) {
                    price =
                        price -
                        (selectedSet.price.priceWithVat -
                            selectedSet.discountPrice.priceWithVat);
                }
                return price;
            },
            priceWithVat: function() {
                return this.price.priceWithVat * this.set.quantity;
            },
            price: function () {
                return this.set.items.reduce(
                    function(total, product) {
                        if(product.isCustom) {
                            total.priceWithVat +=
                                product.quantity *
                                product.variantInfo.price.priceWithVat;
                            total.currency = product.variantInfo.price.currency;
                            return total;
                        } else {
                            total.priceWithVat +=
                                product.quantity *
                                product.variantInfo.price.priceWithoutVat *
                                (product.variantInfo.price.vatRate.rate / 100 + 1);
                            total.currency = product.variantInfo.price.currency;
                            return total;
                        }
                    },
                    {priceWithVat: 0}
                );
            },
            currency: function () {
                return this.price.currency.htmlString;
            },
            currencyCode: function () {
                return this.price.currency.code;
            },
            items: function () {
                return this.set.items;
            },
            collectionFixed: function () {
                return this.$store.state.configurator.collectionFixed || !this.isCurrentCollection;
            },
            isCurrentCollection: function() {
                return this.set.collectionId === this.$store.state.configurator.collectionId
            },
            setMessage : function () {
                return this.$store.state.configurator.configurator.setMessage;
            },
            collectionName: function () {
                return this.set.name;
            },
            productSetName: function () {
                if( this.set.productSet ) {
                    return this.set.productSet.name;
                }
                return '';
            },
            productSetTypeIdentifier: function () {
                if( this.set.productSet ) {
                    return this.set.productSet.productSetType.identifier;
                }
                return '';
            },
            productSetTypeName: function () {
                if( this.set.productSet ) {
                    return this.set.productSet.productSetType.name;
                }
                return '';
            },
            pillowSmallCount: function () {
                return this.countItemByTypeAndTPValue('pillow', 1069, 40783);
            },
            pillowRegularCount: function () {
                return this.countItemByTypeAndTPValue('pillow', 1069, 40784);
            },
            pillowLargeCount: function () {
                return this.countItemByTypeAndTPValue('pillow', 1069, 40785);
            },
            duvetRegularCount: function () {
                return this.countItemByTypeAndTPValue('duvet', 1074, 40795);
            },
            duvetDoubleCount: function () {
                return this.countItemByTypeAndTPValue('duvet', 1074, 40796);
            },
            sheetCount: function () {
                return this.countItemByType('sheet');
            },
            showBedImage: function() {
                if(this.collectionFixed) {
                    return false;
                }
                if(typeof this.set.productSet === "undefined") {
                    return true;
                }
                if(!('productSetType' in this.set.productSet)) {
                    return true;
                }
                if(this.set.productSet.productSetType.id == 1) { //Dont show image when child bed (ProductSetType ID= 1)
                    return false;
                }
                return true;
            },
        },
        methods: {
            setQuanitity: function (value) {
                if(value <= 0) {
                    this.openDeleteConfirmationPopup();
                } else {
                    this.$store.dispatch("changePackQuantity", {
                        collectionId: this.set.collectionId,
                        quantity: value
                    });
                }
            },
            openDeleteConfirmationPopup() {
                this.showConfirmPopup = true;
            },
            submitDelete() {
                this.showConfirmPopup = false;
                this.$store.dispatch('removeConfiguratorItems');
            },
            closeDeleteConfirmationPopup() {
                this.showConfirmPopup = false;
                this.set.quantity = 1;
            },
            countItemByType: function (productTypeCode) {
                var filteredItems = this.set.items.filter(function (item) {
                    if(item.hasOwnProperty('isCustom') && item.isCustom) {
                        return false;
                    }
                    return item.variantInfo.productType.code === productTypeCode;
                });
                var quantity = 0;
                filteredItems.forEach(function (item) {
                    quantity += item.quantity;
                });
                return quantity
            },
            // by Type and technical param value
            countItemByTypeAndTPValue: function (productTypeCode, technicalParamId, technicalParamValueId) {
                var filteredItems = this.set.items.filter(function (item) {
                    if(item.hasOwnProperty('isCustom') && item.isCustom) {
                        return false;
                    }
                    let sizeTP = item.variantInfo.technicalParameters.find(function (tp) {
                        return tp.id == technicalParamId;
                    });
                    return item.variantInfo.productType.code === productTypeCode
                        && sizeTP
                        && sizeTP.value.id == technicalParamValueId;
                });
                var quantity = 0;
                filteredItems.forEach(function (item) {
                    quantity += item.quantity;
                });
                return quantity
            }
        }
    };
</script>
